import React, { useState, useEffect } from "react";
import { t } from "i18next";

const defaultFn= ()=>{}
const SearchInput = ({
  debounce = 300,
  clearSearch=false,
  containerClassName="",
  placeholder = "Search...",
  value: controlledValue = "",
  onSearch=defaultFn,
  onCloseSearch=defaultFn,
}) => {
  const [value, setValue] = useState(controlledValue);
  const [debouncedValue, setDebouncedValue] = useState(value);

  const handleCloseSearch=()=>{
    if(clearSearch){
      setValue("")
    }
    onCloseSearch()
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, debounce);

    return () => {
      clearTimeout(handler);
    };
  }, [value, debounce]);

  useEffect(() => {
      onSearch(debouncedValue);
  }, [debouncedValue]);


  return (
    <div className={`flex items-center bg-svg-stroke rounded-full px-6 py-2 w-full max-w-xl shadow-sm gap-2 input-3d-inner-shadow ${containerClassName}`}>
      {/* Search Icon */}
      <svg
        className="text-gray-500"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        onClick={handleCloseSearch}
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      {/* Input */}
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t(placeholder)}
        className="flex-1 bg-transparent border-none outline-none text-lg text-gray-700 placeholder-gray-400"
        autoFocus={true}
      />
      {/* Clear Button */}
      {/* value && */ (
        <button
          onClick={handleCloseSearch}
          className="focus:outline-none"
          aria-label="Clear"
        >
          <svg
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="text-gray-500"
          >
            <line x1="6" y1="6" x2="18" y2="18" />
            <line x1="18" y1="6" x2="6" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchInput;
